/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import CourseraPlusButton from 'bundles/composable-page-header/components/coursera-plus-button/CourseraPlusButton';

type Props = {
  showTopBorder?: boolean;
};

const styles = {
  linkWrapper: css`
    padding: var(--cds-spacing-100) 0;
    list-style-type: none;

    ${breakpoints.up('md')} {
      a {
        &:hover,
        &:focus {
          /* Inherit the current dropdown item hover color */
          background-color: var(--cds-color-grey-25) !important;
          outline: none !important;
        }
      }
    }
  `,
  linkTopBorder: css`
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    margin-top: var(--cds-spacing-100);
  `,
};

const CourseraPlusButtonListItem = ({ showTopBorder = true }: Props) => {
  return (
    <li css={[styles.linkWrapper, showTopBorder && styles.linkTopBorder]}>
      <CourseraPlusButton />
    </li>
  );
};

export default CourseraPlusButtonListItem;
